import { Capacitor } from "@capacitor/core";

const Seperator = "---";
const platform = Capacitor.getPlatform();

class Localstorage {
    
	static storeValue(key: string, value: any) {
		try {
			switch (platform) {
				case "web":
					let convertedValue: any;
					let expectType = typeof value;

					switch (typeof value) {
						case "string":
							convertedValue = value;
							break;
						case "number":
							convertedValue = value.toString();
							break;
						case "object":
							convertedValue = JSON.stringify(value);
							break;
						default:
							return { error: "Unknown type of value to store" };
					}

					const valueToStore = convertedValue + Seperator + expectType;
					localStorage.setItem(key, valueToStore);
					return { storedKey: key };

				default:
					return { error: `Platform ${platform} not supported` };
			}
		} catch (error) {
			return { error: error };
		}
	}

	static getStoredValue(storedKey: string) {
		try {
			switch (platform) {
				case "web":
					const storedValue = localStorage.getItem(storedKey);
					if (storedValue === null) return { storedKey, storedValue };

					const [value, type] = storedValue.split(Seperator);
					let actualValue: any;

					switch (type) {
						case "string":
							actualValue = value;
							break;
						case "number":
							actualValue = parseFloat(value);
							break;
						case "object":
							actualValue = JSON.parse(value);
							break;
						default:
							return { error: "Unknown type of value to store" };
					}

					return { storedKey, storedValue: actualValue };

				default:
					return { error: `Platform ${platform} not supported` };
			}
		} catch (error) {
			return { error: error };
		}
	}

    static removeStoredValue(storedKey: string) {
        try {
			switch (platform) {
				case "web":
                    localStorage.removeItem(storedKey);
                    return { removedKey: storedKey };
				default:
					return { error: `Platform ${platform} not supported` };
			}
		} catch (error) {
			return { error: error };
		}
    }

    static clearStorage() {
        try {
			switch (platform) {
				case "web":
                    localStorage.clear();
                    return { storageCleared: true };
				default:
					return { error: `Platform ${platform} not supported` };
			}
		} catch (error) {
			return { error: error };
		}
    }
}

export default Localstorage;
